(function () {
  'use strict';

  var root = document.querySelector('[data-pp-whats-new]');
  if (!root) return;

  var releases = Array.prototype.slice.call(root.querySelectorAll('[data-pp-new-release]'));
  if (!releases.length) return;

  var reducedMotion = false;
  try {
    reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  } catch (error) {
    reducedMotion = false;
  }

  if (reducedMotion || !('IntersectionObserver' in window)) {
    releases.forEach(function (release) {
      release.classList.add('is-visible');
    });
    return;
  }

  root.classList.add('pp-new--motion');

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    },
    { rootMargin: '0px 0px -12% 0px', threshold: 0.14 },
  );

  releases.forEach(function (release) {
    observer.observe(release);
  });
})();
